import { TextField } from "@mittwald/flow-components/dist/components/TextField";
import React from "react";
import type { Contract } from "../../../../../types/LegacySystemAPI";
import { ProjectNumberSelect } from "./components/ProjectNumberSelect";

interface PropsNumberInputProps {
  isLoggedIn: boolean;
  contracts: Contract[];
}

export const ProjectNumberInput: React.FC<PropsNumberInputProps> = ({
  isLoggedIn,
  contracts,
}) => {
  return isLoggedIn ? (
    <ProjectNumberSelect
      contracts={contracts}
      label="projectNumber"
      name="target.projectName"
      placeholder="projectNumber.placeholder"
      rules={{ required: true }}
    />
  ) : (
    <TextField
      label="projectNumber"
      name="target.projectName"
      placeholder="projectNumber.placeholder"
      rules={{
        required: true,
        pattern: /^(p[0-9]+)$/,
      }}
    />
  );
};
